import { render, staticRenderFns } from "./ModalCertificadoVinculado.vue?vue&type=template&id=3d4c0fe5&"
import script from "./ModalCertificadoVinculado.vue?vue&type=script&lang=js&"
export * from "./ModalCertificadoVinculado.vue?vue&type=script&lang=js&"
import style0 from "./ModalCertificadoVinculado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports